let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("99qJc")).then(() => parcelRequire('62BDU'));